<div fxLayout="row" fxLayoutAlign="start start">
  <div class="propertyCaption">{{addressType}}</div>
  <div class="text-bold">
    <div>{{address.streetLine1}}</div>
    <div *ngIf="address.streetLine2">{{address.streetLine2}}</div>
    <div> <span>{{address.city}}, {{address.stateProv}} {{address.postalCode}}</span></div>
    <div>{{address.countryName}}</div>
  </div>
</div>